import styles from './FormInputBlock.module.css'

const FormInputContainer = ({ children, style }) => {
  return <div className={styles.scheduleFormInputContainer} style={style}>
    {children}
  </div>
}

const FormInputLabel = ({ children, style }) => {
    return <div className={styles.scheduleFormInputLabel} style={style}>
      {children}
    </div>
}

const FormInput = ({ children, style }) => {
    return <div className={styles.scheduleFormInput} style={style}>
      {children}
    </div>
}

export {FormInputContainer, FormInput, FormInputLabel}